import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  glass?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = true,
  glass = true,
}) => {
  return (
    <div
      className={`
        ${glass ? 'bg-glass' : 'bg-card'}
        rounded-2xl p-6 border border-white/10
        ${hover ? 'hover-lift hover:border-white/20' : ''}
        transition-all duration-300
        ${className}
      `}
      style={{
        backdropFilter: glass ? 'blur(12px)' : undefined,
      }}
    >
      {children}
    </div>
  );
};
